import {computed, makeObservable, observable} from "mobx";
import type {SpaceVersionDto} from "../../generated/api/base";
import type {IModel} from "./Model";

export class SpaceVersion implements IModel {
	private _data: SpaceVersionDto;

	constructor(data: SpaceVersionDto) {
		makeObservable<this, "_data">(this, {
			_data: observable,
			name: computed,
			date: computed,
			data: computed,
		});
		this._data = data;
	}

	public get id() {
		return this._data.spaceVersionID;
	}

	public set name(newName: string) {
		this._data.name = newName;
	}

	public set date(newDate: Date) {
		this._data.date = newDate.toISOString();
	}

	public get name() {
		return this._data.name ?? "";
	}

	public get date() {
		return new Date(this._data.date);
	}

	public get data() {
		return this._data;
	}
}
